import { ProfileActions } from "./ProfileActions";
import { ProfileActivity } from "./ProfileActivity";
import { ProfileBadges } from "./ProfileBadges";
import { ProfileBanner } from "./ProfileBanner";
import { ProfileBio } from "./ProfileBio";
import { ProfileCard } from "./ProfileCard";
import { ProfileJoined } from "./ProfileJoined";
import { ProfileInCommon, ProfileMutuals } from "./ProfileMutuals";
import { ProfileOwner } from "./ProfileOwner";
import { ProfileRoles } from "./ProfileRoles";
import { ProfileStatus } from "./ProfileStatus";

export const Profile = {
  Actions: ProfileActions,
  Activity: ProfileActivity,
  Badges: ProfileBadges,
  Banner: ProfileBanner,
  Bio: ProfileBio,
  Card: ProfileCard,
  InCommon: ProfileInCommon,
  Joined: ProfileJoined,
  Mutuals: ProfileMutuals,
  Roles: ProfileRoles,
  Status: ProfileStatus,
  Owner: ProfileOwner,
};
